import(/* webpackMode: "eager" */ "/home/ubuntu/download/692db9755a241000145a0247/aiva_medical_supply/node_modules/next/dist/client/components/app-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/692db9755a241000145a0247/aiva_medical_supply/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/692db9755a241000145a0247/aiva_medical_supply/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/692db9755a241000145a0247/aiva_medical_supply/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/692db9755a241000145a0247/aiva_medical_supply/node_modules/next/dist/client/components/not-found-boundary.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/692db9755a241000145a0247/aiva_medical_supply/node_modules/next/dist/client/components/render-from-template-context.js");
